import * as types from './types';

export const toggleColorMode = (payload: any) => {
  return {
    type: types.TOGGLE_THEME,
    payload,
  };
};
